import { render, staticRenderFns } from "./assistance-choice-visio-card.component.vue?vue&type=template&id=f020c9f2&"
import script from "./assistance-choice-visio-card.component.vue?vue&type=script&lang=ts&"
export * from "./assistance-choice-visio-card.component.vue?vue&type=script&lang=ts&"
import style0 from "./assistance-choice-visio-card.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "assistance-choice-visio-card.component.vue"
export default component.exports